export default __webpack_public_path__ + "static/media/logoPortal.dcae4c6a.svg";